import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

type Size = 'small' | 'medium' | 'large';

@Component({
  selector: 'lh-shared-ui-access-code',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './shared-ui-access-code.component.html',
  styleUrl: './shared-ui-access-code.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiAccessCodeComponent {
  private _value: string | undefined;
  private _darkMode = false;
  private _size: Size = 'large';

  constructor(private cd: ChangeDetectorRef) {}

  public get value(): string | undefined {
    return this._value;
  }
  @Input() public set value(value: string | undefined) {
    if (this._value !== value) {
      this._value = value;
      this.cd.markForCheck();
    }
  }

  public get darkMode(): boolean {
    return this._darkMode;
  }
  @Input() public set darkMode(value: boolean) {
    if (this._darkMode !== value) {
      this._darkMode = value;
      this.cd.markForCheck();
    }
  }

  public get size(): Size {
    return this._size;
  }
  @Input() public set size(value: Size) {
    if (this._size !== value) {
      this._size = value;
      this.cd.markForCheck();
    }
  }
}
